<div class="d-flex flex-dir-column h-100p">
  <div mat-dialog-title class="flex-0-0-48">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <i class="fas fa-database i-16 mr-6"></i>
        <span>Extended Dataset - Selection</span>
      </div>
      <div>
        <button trgButton class="dialog-close-btn" (click)="close()" [disabled]="busy$ | async">
          <i class="fal fa-times i-12 p-relative"></i>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content class="py-0 pt-15 px-15 flex-grow" style="max-height: none !important">
    <ng-container *ngIf="loading$ | async">
      <app-spinner></app-spinner>
    </ng-container>
    <div [hidden]="loading$ | async" class="h-100p">
      <app-dataset-editor
        [loading]="loading$ | async"
        [busy]="busy$ | async"
        [locale]="locale"
        [user]="user$ | async"
        [globalFilterTypeOptions]="globalFilterTypeOptions$ | async"
        [globalFilter]="globalFilter$ | async"
        (globalFilterChange)="globalFilterChange($event)"
        [searchPatternForDatasets]="searchPatternForDatasets"
        [searchPatternForInputs]="searchPatternForInputs"
        [searchPatternForFields]="searchPatternForFields"
        [showLimitToJoinableDatasets]="showLimitToJoinableDatasets"
        [disableLimitToJoinableDatasetsToggle]="disableLimitToJoinableDatasetsToggle"
        [products]="products$ | async"
        [selectedDatasetId]="selectedDatasetId$ | async"
        (selectedDatasetIdChange)="setSelectedDatasetId($event)"
        [noCorporateStructure]="datasetState.noCorpStructure"
        [product]="product$ | async"
        [dataset]="dataset$ | async"
        [controlGroups]="controlGroups$ | async"
        [filterGroups]="filterGroups$ | async"
        [fieldsLoaded]="fieldsLoaded$ | async"
        [fields]="fields$ | async"
        [datasetTabs]="datasetTabs"
        [selectedDatasetTabIndex]="selectedDatasetTabIndex"
        (selectedDatasetTabIndexChange)="setSelectedDatasetTab($event)"
        [canAddDatasetTabs]="canAddDatasetTabs()"
        (removeDatasetTab)="removeDatasetTab($event)"
        (addDatasetTab)="addDatasetTab($event)"
        (openJoinDialog)="openJoinDialog($event)"
        [spendBillingCenter]="spendBillingCenter"
        (inputChange)="inputChange($event)"
        [validateUIEmitter]="validateUIEmitter"
        [updateFieldsEmitter]="updateFieldsEmitter"
      ></app-dataset-editor>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="dialog-footer px-16 py-10 mt-0 border-box flex-0-0-50">
    <button trgButton color="outline" class="min-w-80 text-center" (click)="close()" [disabled]="busy$ | async">Cancel</button>

    <button
      trgButton
      color="primary"
      class="min-w-80 text-center"
      (click)="save()"
      [disabled]="(busy$ | async) || !datasetState.fieldsLoaded || datasetState.noCorpStructure"
    >
      <span>Load</span>
    </button>
  </div>
</div>

<ng-template #joinDialogTemplate>
  <div class="d-flex flex-dir-column h-100p">
    <div class="join-dialog__section" style="flex: 0 0 225px">
      <div class="join-dialog__section-title">
        <div class="d-flex align-items-center justify-content-between w-100p h-100p">
          <div>
            <i class="fas fa-sitemap i-12 mr-6 fa-rotate-90 p-relative not-1"></i>
            <span>Dataset - Joins</span>
          </div>
          <div>
            <button trgButton class="dialog-close-btn" (click)="closeJoinDialog()" [disabled]="busy$ | async">
              <i class="fas fa-times i-12 p-relative"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        class="py-30 flex-grow overflow-x-hidden"
        style="margin-left: -35px"
        #jointDatasetsContainerDrag
        appDraggable
        dragDirection="horizontal"
        (dragMove)="jointDatasetContainerDragging($event)"
      >
        <div class="d-flex align-items-center jointDatasetsContainer" #jointDatasetsContainer>
          <ng-container *ngFor="let d of joinDialog.datasets; index as i; last as last">
            <div class="join-dataset d-flex flex-dir-column" [class.invalid]="d.invalid" [class.selected]="d.selected">
              <div class="border-box flex-basis-36 join-dataset__header">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-inline-block fs-14 title">Dataset #{{ i + 1 }}</div>
                </div>
              </div>
              <div class="join-dataset__details flex-grow">
                <div class="group">
                  <div class="fs-10 c-light-blue">Name:</div>
                  <div class="fs-12 text-ellipsis mt-2" [title]="d.title">{{ d.title }}</div>
                </div>
                <div class="group mt-8">
                  <div class="fs-10 c-light-blue">Product:</div>
                  <div class="fs-12 text-ellipsis mt-2" [title]="d.product">{{ d.product }}</div>
                </div>
              </div>
            </div>
            <div *ngIf="!last" class="join-type d-flex flex-dir-column align-items-center justify-content-center mx-20">
              <div class="p-relative d-flex flex-dir-column align-items-center">
                <div *ngIf="i == joinDialog.selectedIndex" class="fs-10 p-absolute" style="top: -14px">Join Type</div>
                <div class="join-type__button pointer join-type__button{{ i }}">
                  <ng-container *ngIf="i == joinDialog.selectedIndex; else defaultIcon">
                    <div class="z-index-1 p-relative h-24 border-box">
                      <mat-select
                        class="trg-flat trg-light-blue h-24 fs-12"
                        style="width: 90px"
                        [(ngModel)]="d.joinType"
                        [disabled]="busy$ | async"
                        panelClass="trg-outline trg-outline-dropdown ot-24"
                      >
                        <mat-option *ngFor="let opt of joinTypes" [value]="opt">
                          <div class="d-inline-flex align-items-center w-100p">
                            <img class="h-auto w-30 mr-6" [src]="opt.icon" [title]="opt.title" style="flex: 0 0 30px" />
                            <div>{{ opt.title }}</div>
                          </div>
                        </mat-option>
                      </mat-select>
                    </div>
                  </ng-container>
                  <ng-template #defaultIcon>
                    <div
                      class="z-index-1 p-relative h-24 w-24 border-box bgc-light-blue br-4 d-flex align-items-center justify-content-center"
                      (click)="setJoinDataset(i)"
                    >
                      <i class="fal fa-link i-14 c-white"></i>
                    </div>
                  </ng-template>
                  <div class="join-type__line"></div>
                </div>
                <img class="h-auto w-24 mt-8" [src]="d.joinType.icon" [alt]="d.joinType.title" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="join-dialog__section flex-grow">
      <div class="join-dialog__section-title">
        <div class="d-flex align-items-center w-100p h-100p">
          <div>
            <i class="fas fa-sitemap i-12 mr-6 fa-rotate-90 p-relative not-1"></i>
            <span>Field - Joins</span>
          </div>
        </div>
      </div>

      <div *ngIf="joinLeftDataset && joinRightDataset" class="mt-20 mx-10 flex-grow">
        <div class="px-150">
          <div class="mb-10 d-flex align-items-center justify-content-between">
            <div>
              <button trgButton color="primary" (click)="joinAddField()">
                <i class="far fa-plus i-12 mr-4"></i>
                <span>Add</span>
              </button>
              <button
                trgButton
                color="primary"
                (click)="joinRevertFieldsToDefault()"
                class="ml-10"
                [disabled]="!joinCanResetToDefaults || joinFieldsPristine"
              >
                <i class="far fa-sync i-12 mr-4"></i>
                <span>Revert to Defaults</span>
              </button>
            </div>
            <div>
              <div *ngIf="!hasValidJoinFields()" class="bgc-orange c-white py-4 px-8 br-4 h-24 border-box d-flex align-items-center" style="margin-right: 35px">
                <i class="far fa-exclamation-triangle i-10 mr-5"></i>
                <span class="fs-12">A minimum of one join must be established</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-15" style="margin-right: 35px">
            <div class="flex-grow bgc-blue c-white py-8 px-5 fs-12 text-ellipsis">
              <span>Dataset:</span>
              <span class="bold" [title]="joinLeftDataset.title">{{ joinLeftDataset.title }}</span>
            </div>
            <div class="d-flex justify-content-center" style="width: 94px">
              <img class="h-auto w-30 p-relative ot-2" [src]="joinLeftDataset.joinType.icon" [alt]="joinLeftDataset.joinType.title" />
            </div>
            <div class="flex-grow bgc-blue c-white py-8 px-5 fs-12 text-ellipsis">
              <span>Dataset:</span>
              <span class="bold" [title]="joinRightDataset.title">{{ joinRightDataset.title }}</span>
            </div>
          </div>
        </div>
        <div class="overflow-y-auto pl-150" style="max-height: 174px">
          <div style="padding-right: {{ joinLeftDataset.joinFields.length > 4 ? '143px' : '150px' }}">
            <div *ngFor="let f of joinLeftDataset.joinFields; index as i" class="d-flex align-items-center mb-10">
              <div class="flex-grow">
                <mat-select
                  class="trg-outline h-26 fs-12 w-100p"
                  panelClass="trg-outline trg-outline-dropdown ot-26"
                  [(ngModel)]="f.leftFieldId"
                  (ngModelChange)="joinFieldChange(i)"
                  placeholder="Select Field"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="leftFieldSearchCtrl"
                      placeholderLabel="Enter Search"
                      noEntriesFoundLabel="No fields found"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let opt of joinLeftDatasetFields" [value]="opt.id">
                    {{ opt.title }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="d-flex justify-content-center p-relative" style="width: 94px">
                <div class="z-index-1 p-relative h-24 w-24 border-box bgc-light-blue br-4 d-flex align-items-center justify-content-center">
                  <i class="fal fa-link i-14 c-white"></i>
                </div>
                <div class="join-type__line line-fields"></div>
              </div>
              <div class="flex-grow">
                <mat-select
                  class="trg-outline h-26 fs-12 w-100p"
                  panelClass="trg-outline trg-outline-dropdown ot-26"
                  [(ngModel)]="f.rightFieldId"
                  (ngModelChange)="joinFieldChange(i)"
                  placeholder="Select Field"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="rightFieldSearchCtrl"
                      placeholderLabel="Enter Search"
                      noEntriesFoundLabel="No fields found"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let opt of joinRightDatasetFields" [value]="opt.id">
                    {{ opt.title }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="d-flex justify-content-right" style="width: 35px">
                <button
                  trgButton
                  color="outline"
                  class="field-remove-btn"
                  (click)="joinRemoveField(i)"
                  [disabled]="joinLeftDataset.joinFields.length == 1 && !hasValidJoinFields()"
                >
                  <i class="fas fa-trash-alt i-14"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-15 d-flex align-items-center justify-content-center join-dialog__footer">
      <div>
        <button trgButton color="outline" (click)="closeJoinDialog()" [disabled]="busy$ | async">Close</button>
      </div>
    </div>
  </div>
</ng-template>
